/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { getNameClient } from '../../helpers/nameClient';
import { Row } from 'reactstrap';
import { getTraceability, getTraceabilityFilters } from '../../store/traceabilities/actions';
import './traceabilities.scss';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from 'reactstrap';
import Filters from '../../components/Common/Filters/filters';
import { getDynamicAttrUpdated } from '../../helpers/tools_helper';
import { ITable } from '../../components/Common/iComponents/iTable/ITable';
import moment from 'moment';
import { IPopUp } from '../../components/Common/iComponents/iPopUp/IpopUp';
import IForm from './IForm';
import PageTitle from '../../components/Common/MetaTagsHelper/metaTagsHelper';
import { getIdFromObject } from '../../helpers/tasks_helper';
import { useLoadingModal } from '../../common/hooks/useLoading';
import usePageTitle from '../../common/hooks/usePageTitle';
import Iloading from '../../components/Common/iComponents/iLoading/Iloading';

export const Traceabilities = (props: any) => {
    const dispatch = useDispatch();
    const { listData, CountItems, filterItems, loading } = useSelector((state: any) => state.Traceabilities);
    const [pagination, setPagination] = useState<{
        sizePerPage: number;
        page: number;
    }>({
        sizePerPage: 50,
        page: 1,
    });
    const [popUpState, setpopUpState] = useState(false);
    const [updateState, setUpdateState] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});
    const [title, setTitle] = useState('');

    const PageTitleTraceabilities = usePageTitle(props.location.pathname);

    const currentDate = new Date();
    const { hideProgress, showProgress } = useLoadingModal();

    const [filters, setFilters] = useState({
        from: moment(currentDate).format('YYYY-MM-DD'),
        to: moment(currentDate).format('YYYY-MM-DD'),
        order: "{'createdAt' : 'DESC'}",
        dynamicFilter: '',
    });

    useEffect(() => {
        dispatch(getTraceability({ pagination, filters }));
        dispatch(getTraceabilityFilters());
    }, [dispatch, filters, pagination]);

    const handleTableSort = (type :any, { sortField, sortOrder }:any) => {
        setFilters( {...filters,
            order: `{'${sortField ?? 'createdAt'}' : '${sortOrder.toUpperCase()}'}` 
        })
    }

    const columns = [
        {
            text: 'Date',
            visibleInTable: true,
            dataField: 'createdAt',
        },
        {
            text: 'Operations',
            visibleInTable: true,
            dataField: 'Operation',
        },
        {
            text: 'Number',
            visibleInTable: true,
            dataField: 'Number',
        },
        {
            text: 'Task id',
            visibleInTable: true,
            dataField: 'taskId',
        },
        {
            text: 'Task Description',
            visibleInTable: true,
            formatter: (cellContent: any, log: any) => <>{log?.iTask?.descripcion ?? "Non-TaskId"}</>
        },
        {
            text: 'WR Number',
            visibleInTable: true,
            dataField: 'WRNUMBER',
        },
        {
            text: 'Client Id',
            visibleInTable: true,
            dataField: 'ClientId',
        },
        {
            text: 'Detail 1',
            visibleInTable: true,
            dataField: 'text1',
        },
        {
            text: 'Detail 2',
            visibleInTable: true,
            dataField: 'text2',
        },
        {
            text: 'Detail 3',
            visibleInTable: true,
            dataField: 'text3',
        },
    ];

    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };

    const handleActionOnSearch = (data: any) => {
        if (data.taskId) {
            data.taskId.forEach((t: any) => {
                const id = getIdFromObject(t);
                t.value = id;
            });
        }
        if (data.ClientId) {
            data.ClientId.forEach((c: any) => {
                const id = getIdFromObject(c);
                c.value = id;
            });
        }
        const filterString = getDynamicAttrUpdated(data);
        setFilters((prevFilters) => ({
            ...prevFilters,
            order: filters.order,
            dynamicFilter: filterString,
            from: data.from,
            to: data.to,
        }));
    };

    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };
    const handleActionOnRowClick = (row: any) => {
        setTitle(`${row.id} - ${row.text1}`);
        setSelectedRow(row);
    };

    const groupName = 'TraceabilitiesList';

    return (
        <React.Fragment>
            <div className="page-content">
                {/* <div id="menuColumn"></div> */}
                <PageTitle>
                    <title>{PageTitleTraceabilities.replace(/-/g, ' ')} | {getNameClient()}</title>
                </PageTitle>
                <Container fluid>
                    <div className="container-sm">
                        <Iloading  loading={loading}/>
                    </div>
                    <Row>
                        <Filters groupName={groupName} onSearchClicked={handleActionOnSearch} filterItems={filterItems} />
                    </Row>
                    <Row>
                        <Row>
                            <ITable
                                remote={true}
                                CountItems={CountItems}
                                handlerPaginationState={handlePaginationChange}
                                data={listData}
                                fields={columns}
                                tableColumns={columns}
                                headerColorT="bg-primary text-white"
                                actionOnRowClick={handleActionOnRowClick}
                                handlePopUpState={onPopUpState}
                                groupName={groupName}
                                handleTableSort={handleTableSort}
                            />
                        </Row>
                    </Row>
                </Container>
            </div>
            <IPopUp
                stateAdd={popUpState}
                switchStateAdd={setpopUpState}
                stateUpdate={updateState}
                switchStateUpdate={setUpdateState}
                modalTitleAdd={title}
                modaleTitleUpdate={'Sales Orders'}
                icon="shopping-bag"
                colorHeaderPop={'#101340'}
            >
                <IForm selectedRow={selectedRow} />
            </IPopUp>
        </React.Fragment>
    );
};
